<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{pageTitle}}</h3>
            <div class="box-tools pull-right" style="display: flex;align-items: center;">
              <page-add @finish="finish">新增</page-add>
            </div>
          </div>
          <div class="box-body">

            <el-tabs v-model="query.type_id" @tab-click="typeSelect">
              <el-tab-pane v-for="(item, i) in typeList" :key="i" :label="item.name" :name="item.id + ''"></el-tab-pane>
            </el-tabs>

            <el-card class="box-card" shadow="never">

              <el-table :data="list" border style="width: 100%" v-loading="loading">
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="pay_price" label="支付价格"></el-table-column>
                <el-table-column prop="pay_raw_price" label="原价"></el-table-column>
                <el-table-column prop="duration" label="持续时长"></el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <div style="display: flex;align-items: center;">
                      <page-edit :param="scope.row" @finish="finish">
                        编辑
                      </page-edit>
                      <page-delete :param="scope.row" @finish="finish">
                        删除
                      </page-delete>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

            </el-card>

            <div style="height: 20px;"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mapState} from "vuex";

import PageAdd from '@/views/goods/scheme/Add.vue';
import PageEdit from '@/views/goods/scheme/Edit.vue';
import PageDelete from '@/views/goods/scheme/Delete.vue';

export default {
  components: {
    PageAdd,
    PageEdit,
    PageDelete
  },
  data() {
    return {
      loading: false,
      query: {
        type_id: '0',
      },
      list: [],
      typeList: [],
    };
  },
  computed: mapState({
    config: (state) => state.config,
    pageTitle: (state) => state.pageTitle,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query)
    _this.loading = true;
    _this.$store
        .dispatch('authInit', _this)
        .then(() => {
          _this.loadSelect();
        })
        .catch(() => {
          _this.loading = false;
        })
  },
  methods: {
    updateUrl() {
      const _this = this;
      const url = _this.$queryUrl(_this.$route.path, _this.query);
      _this.$router.replace({path: url});
    },
    loadSelect() {
      const _this = this;
      _this.$apiAdmin.adminSchemeTypeList()
          .then(res => {
            _this.typeList = res.type_list;
            if (_this.typeList.length > 0 && _this.query.type_id === '0') {
              _this.query.type_id = _this.typeList[0].id + '';
            }
            _this.loadList();
          })
          .catch(err => {
            _this.loading = false;
            _this.updateUrl();
          })
    },
    loadList() {
      const _this = this;
      _this.$apiAdmin.adminSchemeList(_this.query)
          .then(res => {
            _this.loading = false;
            _this.list = res.list;
            _this.updateUrl();
          })
          .catch(err => {
            _this.loading = false;
            _this.updateUrl();
          })
    },
    typeSelect() {
      const _this = this;
      _this.loading = true;
      _this.loadList();
    },
    finish(res) {
      const _this = this;
      _this.loading = true;
      if (res.type_id && parseInt(res.type_id) !== 0) {
        _this.query.type_id = res.type_id + '';
      }
      _this.loadList();
    }
  }
}
</script>


<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>